export enum Constants {
    ABSTRACT_ACTION = 'abstract-action',

    LOAD_DATA = 'load-data',
    LOAD_DATA_FINISH = 'load-data-finish',

    SIGN_IN = 'sign-in',
    SIGN_IN_WITH_OPENID = 'sign-in-with-open-id',
    SIGN_OUT = 'sign-out',
    SHOW_ERROR_FORM = 'show-error-form',

    STORE_CACHE_READ = 'store-cache-read',
    STORE_CACHE_CLEAN = 'store-cache-clean',

    NOTIFICATION_SHOW = 'notification-show',
    NOTIFICATION_CLEAN = 'notification-clean',
    CLEAN_WIDGET_NOTIFICATIONS = 'widget-notification-clean',
    CLEAN_REMAINDER_MESSAGE = 'remainder-message-clean',
    LOADING_PANEL_SHOW = 'loading-panel-show',
    LOADING_PANEL_HIDE = 'loading-panel-hide',

    INITIAL_LOAD = 'initial-load',
    INITIAL_LOAD_FINISH = 'initial-load-finish',

    APP_SETTINGS_GET_DESCRIPTION = 'app-settings-get-description',
    APP_SETTINGS_GET_DESCRIPTION_FINISH = 'app-settings-get-description-finish',
    APP_SETTINGS_GET = 'app-settings-get',
    APP_SETTINGS_GET_FINISH = 'app-settings-get-finish',
    APP_SETTINGS_SET = 'app-settings-set',
    APP_SETTINGS_SET_FINISH = 'app-settings-set-finish',
    APP_SETTINGS_APPLY_CHANGES = 'app-settings-apply-changes',
    APP_SETTINGS_GET_DEFAULT_THEME = 'app-settings-get-default-theme',
    APP_SETTINGS_GET_DEFAULT_THEME_FINISH = 'app-settings-get-default-theme-finish',
    APP_SETTINGS_TEST_EMAIL_SEND = 'app-settings-test-email-send',

    WORKSPACE_SHOW = 'workspace-show',
    WORKSPACE_HIDE = 'workspace-hide',
    WORKSPACE_CONTENT_LOAD = 'workspace-content-load',
    WORKSPACE_CONTENT_LOAD_FINISH = 'workspace-content-load-finish',
    WORKSPACE_UPDATE_INITIATE = 'workspace-update-initiate',
    WORKSPACE_SET_STATE = 'workspace-set-state',
    WORKSPACE_SHOW_SIDEBAR = 'workspace-show-sidebar',
    WORKSPACE_HIDE_SIDEBAR = 'workspace-hide-sidebar',
    WORKSPACE_SET_CONTENT_CHANGED = 'workspace-set-content-changed',
    WORKSPACE_SAVE = 'workspace-save',
    WORKSPACE_SAVE_AS = 'workspace-save-as',
    WORKSPACE_SAVE_FINISH = 'workspace-save-finish',
    WORKSPACE_RESET = 'workspace-reset',
    WORKSPACE_RESET_FINISH = 'workspace-reset-finish',
    WORKSPACE_DELETE = 'workspace-delete',
    WORKSPACE_DELETE_FINISH = 'workspace-delete-finish',
    WORKSPACE_CREATE_NEW = 'workspace-create-new',
    WORKSPACE_RENAME = 'workspace-rename',
    WORKSPACE_DIRS_RENAME = 'workspace-dirs-rename',
    WORKSPACE_MOVE = 'workspace-move',
    WORKSPACE_MOVE_FINISH = 'workspace-move-finish',
    WORKSPACE_CUSTOM_MENU_LOAD = 'workspace-custom-menu-load',
    WORKSPACE_CUSTOM_MENU_LOAD_FINISH = 'workspace-custom-menu-load-finish',
    WORKSPACE_SET_ACTIONS_MENU_IS_SHOWN = 'workspace-set-actions-menu-is-shown',
    WORKSPACE_SHOW_DIR_SELECT = 'workspace-show-dir-select',
    WORKSPACE_HIDE_DIR_SELECT = 'workspace-hide-dir-select',
    WORKSPACE_CREATE_SAVE = 'workspace-create-save',
    WORKSPACE_CREATE_SAVE_COMPLETE = 'workspace-create-save-complete',
    WORKSPACE_FAVOURITES_ADD = 'workspace-favourites-add',
    WORKSPACE_FAVOURITES_ADD_FINISH = 'workspace-favourites-add-finish',
    WORKSPACE_FAVOURITES_REMOVE = 'workspace-favourites-remove',
    WORKSPACE_FAVOURITES_REMOVE_FINISH = 'workspace-favourites-remove-finish',
    WORKSPACE_BUFFERED_DATA_CHANGED = 'workspace-buffered-data-changed',
    //WORKSPACE_TRANSFORM_STATE = 'workspace-transform-state',
    WORKSPACE_SET_THEME = 'workspace-set-theme',
    WORKSPACE_CLEAR_CACHE = 'workspace-clear-cache',
    WORKSPACE_GET_INFO = 'workspace-get-info',
    WORKSPACE_GET_INFO_FINISH = 'workspace-get-info-finish',
    WORKSPACE_WIDGET_SET_HIDDEN = 'workspace-widget-set-hidden',
    WORKSPACE_SAVE_STATE = 'workspace-save-state',
    WORKSPACE_APPLY_CHANGES = 'workspace-apply-changes',
    WORKSPACE_BEFORE_CLOSE = 'workspace-before-close',
    WORKSPACE_LAYOUT_RESET = 'workspace-layout-reset',
    WORKSPACE_LAYOUT_SET = 'workspace-layout-set',
    WORKSPACE_DO_DRILL_DOWN = 'workspace-do-drill-down',
    WORKSPACE_DRILL_DOWN_RESET = 'workspace-drill-down-reset',
    WORKSPACE_DIRS_SHOW = 'workspace-dirs-show',
    WORKSPACE_DIRS_HIDE = 'workspace-dirs-hide',
    WORKSPACE_VIEW_SHOW = 'workspace-view-show',
    WORKSPACE_VIEW_HIDE = 'workspace-view-hide',
    WORKSPACE_VIEW_OPEN = 'workspace-view-open',
    WORKSPACE_WIDGET_VIEW_OPEN = 'workspace-widget-view-open',
    WORKSPACE_APP_VIEW_OPEN = 'workspace-app-view-open',
    WORKSPACE_APP_VIEW_CLOSE = 'workspace-app-view-close',
    WORKSPACE_VIEW_CLOSE = 'workspace-view-close',
    WORKSPACE_VIEW_CONTENT_LOAD = 'workspace-view-content-load',
    WORKSPACE_VIEW_CONTENT_LOAD_FINISH = 'workspace-view-content-load-finish',
    WORKSPACE_CREATE_LINK = 'workspace-create-link',
    WORKSPACE_ADD_WIDGET = 'workspace-add-widget',
    WORKSPACE_TEMPLATES_EXPLORER_SHOW = 'workspace-templates-explorer-show',
    WORKSPACE_TEMPLATES_EXPLORER_HIDE = 'workspace-templates-explorer-hide',
    WORKSPACE_TEMPLATE_LOAD = 'workspace-template-load',
    WORKSPACE_TEMPLATE_LOAD_FINISH = 'workspace-template-load-finish',
    WORKSPACE_NOTIFY_FOREIGN_UPDATE = 'workspace-notify-foreign-update',

    WIDGET_SET_ROLE = 'widget-set-role',
    WIDGET_UNSET_ROLE = 'widget-unset-role',
    WIDGET_SET_HIDDEN = 'widget-set-hidden',
    WIDGET_DO_CLICK_TO_FILTER = 'widget-do-click-to-filter',
    WIDGET_DO_DRILL_DOWN = 'widget-do-drill-down',
    WIDGET_EDIT = 'widget-edit',
    WIDGET_EDIT_SHOW = 'widget-edit-show',
    WIDGET_EDIT_HIDE = 'widget-edit-hide',
    WIDGET_SAVE = 'widget-save',
    WIDGET_CREATE = 'widget-create',
    WIDGET_REMOVE = 'widget-remove',
    WIDGET_DETACH = 'widget-detach',
    WIDGET_ATTACH = 'widget-attach',
    WIDGET_CREATE_LINK = 'widget-create-link',
    WIDGET_CREATE_LINK_CALL_DIALOG = 'widget-create-link-call-dialog',
    WIDGET_SET_STATE = 'widget-set-state',
    WIDGET_MODULE_LOAD_START = 'widget-module-load-start',
    WIDGET_MODULE_LOAD_FINISH = 'widget-module-load-finish',
    WIDGET_SET_LAYOUT = 'widget-set-layout',
    WIDGET_ADD_FIELD = 'widget-add-field',
    WIDGET_REMOVE_FIELD = 'widget-remove-field',
    WIDGET_UPDATE_OPTIONS = 'widget-update-options',
    WIDGET_ADD_CHILD = 'widget-add-child',
    WIDGET_EXPORT_TO_EXCEL = 'widget-export-to-excel',
    WIDGET_EXPORT_TO_EXCEL_FINISH = 'widget-export-to-excel-finish',
    WIDGET_EXPORT_TO_PDF = 'widget-export-to-pdf',
    WIDGET_CREATE_FROM_WORKSPACE = 'widget-create-from-workspace',
    WIDGET_MULTIPLE_SET_ACTIVE = 'widget-multiple-set-active',
    WIDGET_DRILLDOWN_SET_STATE = 'widget-drilldown-set-state',
    WIDGET_RESET_LAYOUT = 'widget-reset-layout',
    WIDGET_REPAINT_ON_DOCK = 'widget-repaint-on-dock',

    THEME_GET = 'theme-get',
    THEME_GET_FINISH = 'theme-get-finish',
    THEME_GET_LIST = 'theme-get-list',
    THEME_GET_LIST_FINISH = 'theme-get-list-finish',
    THEME_CREATE = 'theme-create',
    THEME_CREATE_FINISH = 'theme-create-finish',
    THEME_UPDATE = 'theme-update',
    THEME_UPDATE_FINISH = 'theme-update-finish',
    THEME_RENAME = 'theme-rename',
    THEME_RENAME_FINISH = 'theme-rename-finish',
    THEME_DELETE = 'theme-delete',
    THEME_DELETE_FINISH = 'theme-delete-finish',

    FILTERS_ARE_ON_SHELF = 'filters-are-on-shelf',
    FILTERS_RESET = 'filters-reset',

    TOOLBAR_BUTTONS_CANCEL_ON = 'toolbar-buttons-cancel-on',
    TOOLBAR_BUTTONS_CANCEL_OFF = 'toolbar-buttons-cancel-off',
    TOOLBAR_BUTTONS_SWITCH_APPLY = 'toolbar-buttons-switch-apply',

    UPDATE_TIME = 'update-time',
    SET_AUTH_FIELD = 'set-auth-field',
    AUTH_FINISH = 'auth-finish',
    AUTH_REFRESH_TOKEN = 'auth-refresh-token',
    ADD_TAB = 'add-tab',
    REORDER_TABS = 'reorder-tabs',
    CLOSE_ALL_OPENED_TABS = 'close-all-opened-tabs',

    SAVE_USER_SETTINGS = 'save-user-settings',
    RECOVER_PASSWORD_REQUEST = 'recover-password-request',
    RECOVER_PASSWORD_REQUEST_FINISH = 'recover-password-request-finish',
    RECOVER_PASSWORD_REQUEST_RESET = 'recover-password-request-reset',
    CHANGE_PASSWORD = 'change-password',
    CHANGE_PASSWORD_FINISH = 'change-password-finish',
    UNAUTHORIZED = 'unauthorized',

    PASSWORD_RESET_START = 'password-reset-start',
    PASSWORD_RESET_END = 'password-reset-end',
    PASSWORD_RESET_REQUEST = 'password-reset-request',
    PASSWORD_RESET_REQUEST_FINISH = 'password-reset-request-finish',
    PASSWORD_GET_REQUIREMENTS = 'password-get-requirements',
    PASSWORD_GET_REQUIREMENTS_FINISH = 'password-get-requirements-finish',

    APPROVE_NEW_DEVICE_START = 'approve-new-device-start',
    APPROVE_NEW_DEVICE = 'approve-new-device',

    USER_SETTINGS_LOAD_DESCRIPTION = 'user-settings-load-description',
    USER_SETTINGS_LOAD_DESCRIPTION_FINISH = 'user-settings-load-description-finish',

    MAIN_VIEW_SHOW = 'main-view-show',
    MAIN_VIEW_HIDE = 'main-view-hide',

    DIRS_CONTENT_LOAD = 'dirs-content-load',
    DIRS_CONTENT_LOAD_FINISH = 'dirs-content-load-finish',
    DIRS_USER_GROUP_CONTENT_LOAD = 'dirs-user-group-content-load',
    DIRS_USER_GROUP_CONTENT_LOAD_FINISH = 'dirs-user-group-content-load-finish',
    DIRS_RENAME_START = 'dirs-rename-start',
    DIRS_RENAME_END = 'dirs-rename-end',
    DIRS_RENAME_FINISH = 'dirs-rename-finish',
    DIRS_CREATE_START = 'dirs-create-start',
    DIRS_DELETE = 'dirs-delete',
    DIRS_DELETE_FINISH = 'dirs-delete-finish',
    DIRS_MOVE = 'dirs-move',
    DIRS_MOVE_FINISH = 'dirs-move-finish',
    DIRS_CLEAN_CACHE = 'dirs-clean-cache',

    DIRS_SHOW = 'dirs-show',
    DIRS_HIDE = 'dirs-hide',
    DIRS_SELECT = 'dirs-select',
    DIRS_OPEN = 'dirs-open',
    DIRS_SINGLE_LOAD = 'dirs-single-load',
    DIRS_SINGLE_LOAD_FINISH = 'dirs-single-load-finish',
    DIRS_SELECT_WORKSPACE = 'dirs-select-workspace',

    MULTI_WIDGET_WORKSPACE_OFFSET = 'multi-widget-workspace-offset',

    TEMPLATE_SHOW = 'template-show',
    TEMPLATE_HIDE = 'template-hide',
    TEMPLATE_CONTENT_LOAD = 'template-content-load',
    TEMPLATE_CONTENT_LOAD_FINISH = 'template-content-load-finish',
    TEMPLATE_SAVE = 'template-save',
    TEMPLATE_SAVE_FINISH = 'template-save-finish',
    TEMPLATE_DELETE = 'template-delete',
    TEMPLATE_DELETE_FINISH = 'template-delete-finish',
    TEMPLATE_CREATE_NEW = 'template-create-new',
    TEMPLATE_RENAME = 'template-rename',
    TEMPLATE_RENAME_START = 'template-rename-start',
    TEMPLATE_RENAME_END = 'template-rename-end',
    TEMPLATE_RENAME_FINISH = 'template-rename-finish',
    TEMPLATE_MOVE = 'template-move',
    TEMPLATE_MOVE_FINISH = 'template-move-finish',
    TEMPLATE_CREATE_SAVE = 'template-create-save',
    TEMPLATE_CREATE_SAVE_COMPLETE = 'template-create-save-complete',
    TEMPLATE_SET_LOCK = 'template-set-lock',

    TEMPLATES_EXPLORER_SHOW = 'templates-explorer-show',
    TEMPLATES_EXPLORER_HIDE = 'templates-explorer-hide',
    TEMPLATES_EXPLORER_CLEAR = 'templates-explorer-clear',
    TEMPLATES_EXPLORER_SINGLE_LOAD = 'templates-explorer-single-load',
    TEMPLATES_EXPLORER_SINGLE_LOAD_FINISH = 'templates-explorer-single-load-finish',
    TEMPLATES_EXPLORER_SET_DISPLAY_ID = 'templates-explorer-set-display-id',

    WORKSPACES_EXPLORER_SHOW = 'workspaces-explorer-show',
    WORKSPACES_EXPLORER_HIDE = 'workspaces-explorer-hide',
    WORKSPACES_EXPLORER_CLEAR = 'workspaces-explorer-clear',
    WORKSPACES_EXPLORER_SINGLE_LOAD = 'workspaces-explorer-single-load',
    WORKSPACES_EXPLORER_SINGLE_LOAD_FINISH = 'workspaces-explorer-single-load-finish',
    WORKSPACES_EXPLORER_SET_DISPLAY_ID = 'workspaces-explorer-set-display-id',
    WORKSPACES_NAV_SET_SECTION = 'workspaces-nav-set-section',

    PERMISSIONS_INITIAL_DATA_LOAD = 'permissions-initial-data-load',
    PERMISSIONS_INITIAL_DATA_LOAD_FINISH = 'permissions-initial-data-load-finish',
    PERMISSIONS_LOAD_DIR = 'permissions-load-dir',
    PERMISSIONS_LOAD_DIR_FINISH = 'permissions-load-dir-finish',
    PERMISSIONS_DIR_SHOW = 'permissions-dir-show',
    PERMISSIONS_DIR_HIDE = 'permissions-dir-hide',
    PERMISSIONS_DIR_SAVE = 'permissions-dir-save',

    ADD_HOME_DIR = 'add-home-dir',
    DELETE_HOME_DIR = 'delete-home-dir',
    GET_HOME_DIR = 'get-home-dir',

    CONFIG_SET_FIELD_VALUES = 'config-set-field-values',
    CONFIG_SET_WIDGET_TYPE = 'config-set-widget-type',
    CONFIG_SET_WIDGET_LAYOUT = 'config-set-widget-layout',

    COMPONENT_SHOW = 'component-show',
    SET_WIDGET_TAB_THEME = 'set-widget-tab-theme',

    SET_WORKSPACE_PRESENTATION_MODE = 'set-workspace-presentation-mode',
    SHOW_WORKSPACE_TEMPLATE_SIDEBAR = 'show-workspace-template-sidebar',

    DROP_WORKSPACE_QUERY = 'drop-workspace-query',

    USER_PERMISSIONS_LOAD_DESCRIPTION = 'user-permissions-load-description',
    USER_PERMISSIONS_LOAD_USER = 'user-permissions-load-user',

    USERS_GROUPS_DATA_UPDATED = 'users-groups-data-updated',

    PAGE_VISIBILITY_CHANGE = 'page-visibility-change',
    TOGGLE_FULL_SCREEN_MODE = 'toggle-full-screen-mode',
    SET_LOCK_ESCAPE = 'set-lock-escape',

    CALL_DATA_EDIT_DIALOG = 'call-data-edit-dialog'
}
